import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportInvoiceListItem = ResultOf<
  typeof reportInvoiceListQuery
>["reportInvoices"][number];

export const reportInvoiceListQuery = graphql(`
  query ReportInvoiceList($rangeStartDate: String!, $rangeEndDate: String!) {
    reportInvoices(
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      id
      invoice_reference
      customer_name
      invoice_date
      currency
      date_paid
      payment_method
      amount_inc_tax
      amount_paid
      amount_due
      invoice_status
      managed_by_name
      payments {
        payment_reference
        payment_date
        amount
        payment_method
        payment_description
      }
    }
  }
`);
